import { message } from 'antd';
import queryString from 'query-string';
import { all, put, takeEvery } from 'redux-saga/effects';

import * as picturesActions from 'app/redux/actions/pictures';
import { del, get, patch, requestGenerator } from 'app/redux/requests';

export function* tryEditPicture({ picture }) {
  yield requestGenerator(
    () => Promise.resolve,
    () => patch(`pictures/${picture.id}`, picture),
    () => put(picturesActions.editPictureSuccess(picture)),
    () => message.error('Error editing picture from hotel gallery')
  );
}

export function* tryRemoveHotelPicture({ hotelId, id }) {
  yield requestGenerator(
    () => Promise.resolve,
    () => del(`hotels/${hotelId}/pictures/${id}`),
    () => put(picturesActions.removeHotelPictureSuccess(id)),
    () => message.error('Error removing picture from hotel gallery')
  );
}

export function* tryFetchHotelsGalleries({ search, limit, sorting, offset }) {
  yield requestGenerator(
    () => put(picturesActions.startLoading()),
    () => {
      const stringifiedParams = queryString.stringify({
        search,
        limit,
        sorting,
        offset,
      });

      return get(`hotels/galleriesOpti?${stringifiedParams}`);
    },
    (result) => put(picturesActions.fetchHotelsGalleriesSuccess(result)),
    () => {
      message.error('Error fetching Hotels Galleries');

      return put(picturesActions.stopLoading());
    }
  );
}

export function* tryFetchHotelGalleryRooms({ hotelId }) {
  yield requestGenerator(
    () => Promise.resolve,
    () => get(`hotels/${hotelId}/gallery/rooms`),
    (result) => put(picturesActions.fetchHotelGalleryRoomsSuccess(result)),
    () => message.error('Error fetching Hotel gallery rooms')
  );
}

export function* tryFetchEmojis() {
  yield requestGenerator(
    () => Promise.resolve,
    () => get('pictures/emojis'),
    (result) => put(picturesActions.fetchEmojisSuccess(result)),
    () => message.error('Error fetching Emojis')
  );
}

export function* picturesSaga() {
  yield all([
    takeEvery(
      picturesActions.actions.PICTURES_TRY_EDIT_PICTURE,
      tryEditPicture
    ),
    takeEvery(
      picturesActions.actions.PICTURES_TRY_REMOVE_HOTEL_PICTURE,
      tryRemoveHotelPicture
    ),
    takeEvery(
      picturesActions.actions.PICTURES_TRY_FETCH_HOTELS_GALLERIES,
      tryFetchHotelsGalleries
    ),
    takeEvery(
      picturesActions.actions.PICTURES_TRY_FETCH_HOTEL_GALLERY_ROOMS,
      tryFetchHotelGalleryRooms
    ),
    takeEvery(
      picturesActions.actions.PICTURES_TRY_FETCH_EMOJIS,
      tryFetchEmojis
    ),
  ]);
}
